var _desc, _defs, _rect, _rect2, _g, _g2, _circle, _g3, _circle2, _circle3, _g4, _circle4, _circle5, _g5, _circle6, _g6, _g7, _path, _path2, _polyline, _polyline2, _polyline3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsArchitectureDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 320",
    width: 1080,
    height: 320,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "PolyFlow \u2014 AWS Pipeline (Dark)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Dark thumbnail: IoT \u2192 Kinesis \u2192 EKS \u2192 EventBridge \u2192 Aurora/SNS inside AWS Cloud. Minimal polyline for card.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ds",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 12,
    floodColor: "#000",
    floodOpacity: 0.45
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrD",
    viewBox: "0 0 10 10",
    refX: 8.5,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#cbd5e1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 320,
    rx: 16,
    fill: "#0a0a0f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 1056,
    height: 296,
    rx: 16,
    fill: "rgba(255,255,255,0.02)",
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1.4,
    strokeDasharray: "10 7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 20,
    rx: 10,
    fill: "rgba(255,153,0,0.14)",
    stroke: "rgba(255,153,0,0.28)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 14.5,
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 9.5,
    fontWeight: 700,
    letterSpacing: "0.06em",
    fill: "#ffd9a6"
  }, "AWS Cloud"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 178,
    height: 104,
    rx: 14,
    fill: "#12121a",
    stroke: "rgba(255,255,255,0.08)",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 178,
    height: 26,
    rx: 14,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 75,
    width: 178,
    height: 13,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 79,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.11em",
    fill: "#8b8ba8"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "rgba(255,153,0,0.16)",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u25C9")), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 142,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#f0f0f5"
  }, "IoT Core"), /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 157,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 10.5,
    fill: "#a0a0b8"
  }, "Greengrass"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 114,
    r: 3.2,
    fill: "#cbd5e1",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 62,
    width: 178,
    height: 104,
    rx: 14,
    fill: "#12121a",
    stroke: "rgba(255,255,255,0.08)",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 62,
    width: 178,
    height: 26,
    rx: 14,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 75,
    width: 178,
    height: 13,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 341,
    y: 79,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.11em",
    fill: "#8b8ba8"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "rgba(255,153,0,0.16)",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u224B")), /*#__PURE__*/React.createElement("text", {
    x: 341,
    y: 142,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#f0f0f5"
  }, "Kinesis"), /*#__PURE__*/React.createElement("text", {
    x: 341,
    y: 157,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 10.5,
    fill: "#a0a0b8"
  }, "Streams"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 114,
    r: 3.2,
    fill: "#6b7280",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 114,
    r: 3.2,
    fill: "#cbd5e1",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 62,
    width: 178,
    height: 104,
    rx: 14,
    fill: "#12121a",
    stroke: "rgba(255,255,255,0.08)",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 62,
    width: 178,
    height: 26,
    rx: 14,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 75,
    width: 178,
    height: 13,
    fill: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 79,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    letterSpacing: "0.11em",
    fill: "#8b8ba8"
  }, "SERVER"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "rgba(255,153,0,0.16)",
    stroke: "#FF9900",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#FF9900"
  }, "\u2B22")), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 142,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#f0f0f5"
  }, "EKS Pods"), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 157,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 10.5,
    fill: "#a0a0b8"
  }, "isolated"))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 476,
    cy: 114,
    r: 3.2,
    fill: "#6b7280",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 654,
    cy: 114,
    r: 3.2,
    fill: "#cbd5e1",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 62,
    width: 178,
    height: 104,
    rx: 14,
    fill: "#12121a",
    stroke: "rgba(255,255,255,0.14)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 62,
    width: 178,
    height: 26,
    rx: 14,
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 75,
    width: 178,
    height: 13,
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 789,
    y: 79,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 700,
    letterSpacing: "0.09em",
    fill: "#e2e8f0"
  }, "HUB"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 18,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#ffffff"
  }, "\u2B21")), /*#__PURE__*/React.createElement("text", {
    x: 789,
    y: 142,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#f0f0f5"
  }, "EventBridge"), /*#__PURE__*/React.createElement("text", {
    x: 789,
    y: 157,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 10.5,
    fill: "#a0a0b8"
  }, "bus"))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 114,
    r: 3.2,
    fill: "#6b7280",
    stroke: "#0a0a0f",
    strokeWidth: 1.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#0f172a",
    stroke: "#1e3a8a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3.5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 15,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#bfdbfe"
  }, "AURORA"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(792,182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#0f172a",
    stroke: "#7c4a0a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3.5,
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 15,
    textAnchor: "middle",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#ffedd5"
  }, "SNS"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 789 166 L 789 182",
    fill: "none",
    stroke: "#475569",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 743 182 L 789 182 L 835 182",
    fill: "none",
    stroke: "#475569",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "206,114 229,114 252,114",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    markerEnd: "url(#arrD)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "430,114 453,114 476,114",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    markerEnd: "url(#arrD)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "654,114 677,114 700,114",
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    markerEnd: "url(#arrD)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1062,
    y: 298,
    textAnchor: "end",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 7.5,
    fill: "#475569"
  }, "polyline \u2022 dark \u2022 tap to expand")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsArchitectureDark);
export default __webpack_public_path__ + "static/media/aws-architecture-dark.5d491daf0a8128d3333bdc1729a9dc5e.svg";
export { ForwardRef as ReactComponent };